import React from "react";
import { Navigate, Outlet, useLocation } from "react-router-dom";
import { useAuth } from "./AuthContext";

const MUST_CHANGE_PASSWORD_ROLES = new Set(["CompanyAdmin", "Teacher", "Student"]);

export default function RequireAuth({
	allowedRoles,
	loginPath = "/login",
	allowMustChangePassword = false,
}) {
	const { access, activeRole, bootstrapping, user } = useAuth();
	const location = useLocation();

	if (bootstrapping)
		return <div style={{ padding: 24 }}>Cargando sesión...</div>;

	if (!access) {
		return (
			<Navigate
				to={loginPath}
				replace
				state={{ from: location.pathname }}
			/>
		);
	}

	if (
		!allowMustChangePassword &&
		user?.mustChangePassword &&
		MUST_CHANGE_PASSWORD_ROLES.has(activeRole)
	) {
		return (
			<Navigate
				to="/cambiar-clave"
				replace
				state={{ from: location.pathname }}
			/>
		);
	}

	if (allowedRoles && (!activeRole || !allowedRoles.includes(activeRole))) {
		return <Navigate to="/unauthorized" replace />;
	}

	return <Outlet />;
}
